import { useState } from "react";
import { generatePath, useRouteMatch } from "react-router-dom";
import type { TemplatePathContextValue } from "@/react/components/shared/Emails/Templates/TemplatePathContext";

export const useEditorUrls = () => {
  const { path: currentPath, params } = useRouteMatch();
  const [editorUrls, setEditorUrls] = useState<TemplatePathContextValue>({
    contentPath: "",
    editPath: "",
    listTemplatePath: "",
    previewTemplatePath: "",
    visualBuilderPath: "",
  });

  const contentPath = `${currentPath}/send-email/:broadcastId`;
  const visualBuilderPath = `${contentPath}/visual-builder`;

  const setEditorUrlsForBroadcast = (broadcastId: string) => {
    // We need only contentPath and visualBuilderPath for the editor urls
    // because the listTemplatePath and previewTemplatePath are not used in the editor selection modal
    setEditorUrls({
      editPath: "",
      listTemplatePath: "",
      previewTemplatePath: "",
      visualBuilderPath: generatePath(visualBuilderPath, {
        broadcastId,
        ...params,
      }),
      contentPath: generatePath(contentPath, {
        broadcastId,
        ...params,
      }),
    });
  };

  return { editorUrls, setEditorUrlsForBroadcast };
};
